// extracted by mini-css-extract-plugin
export default {"section":"b3fpUl","option":"c3fpUl","selected":"d3fpUl"};